export default __webpack_public_path__ + "static/media/logo-icon.f32a7470.svg";